export default __webpack_public_path__ + "static/partners-a5fafeee1509724bf618b3f69e3f6af7.png";